import { c as _c } from "react/compiler-runtime";
interface NftSuggestFooterProps {
  readonly hiddenCount: number;
  readonly onToggleSpam: () => void;
}
export function NftSuggestFooter(t0) {
  const $ = _c(5);
  const {
    hiddenCount,
    onToggleSpam
  } = t0;
  if (hiddenCount <= 0) {
    return null;
  }
  let t1;
  if ($[0] !== onToggleSpam) {
    t1 = <button type="button" className="tw-ml-2 tw-text-primary-400 hover:tw-underline" onClick={onToggleSpam}>Show anyway</button>;
    $[0] = onToggleSpam;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hiddenCount || $[3] !== t1) {
    t2 = <div className="tw-border-t tw-border-iron-700 tw-px-3 tw-py-2 tw-text-xs tw-text-amber-300">Filtered suspected spam collections ({hiddenCount}).{t1}</div>;
    $[2] = hiddenCount;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}